if (!customElements.get("product-tabs")) {
  class ProductTabs extends HTMLElement {
    constructor() {
      super();
      this.id = this.getAttribute("id");

      if (Shopify.designMode) {
        window.addEventListener(
          "shopify:section:load",
          this.init.bind(this)
        );
      }
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.querySelectorAll(".product__tab--trigger").forEach(
        tabTrigger => {
          tabTrigger.addEventListener("click", evt => {
            this.openTab(
              evt,
              tabTrigger.dataset.tab
            );
          });
        }
      );

      this.openDefaultTab();
    }

    openDefaultTab() {
      const event = new MouseEvent("click", {
        view: window,
        bubbles: true,
        cancelable: true
      });

      this.querySelector(
        ".product__tab[data-default-open]"
      )?.dispatchEvent(event);
    }

    openTab(evt, tabName) {
      const tabcontents = this.querySelectorAll(
        ".product__tab-content"
      );
      tabcontents.forEach(content => {
        content.style.display = "none";
      });

      const tablinks = this.querySelectorAll(".product__tab");
      tablinks.forEach(link => {
        link.classList.remove("active");
      });

      const currentTabContent = this.querySelector(`#${tabName}`);

      if (currentTabContent) {
        currentTabContent.style.display = "block";
        if (evt.currentTarget) {
          evt.currentTarget.classList.add("active");
        }
      }
    }
  }
  customElements.define("product-tabs", ProductTabs);
}


/* EW 30-08-2026: redisenio opcion A — pestanias en acordeon con iconos, bloque
   "Good to know" que agrupa las notas sueltas de debajo, y medidas legibles
   (120X60X75CM -> 120 × 60 × 75 cm, solo el texto visible; el value del input
   no se toca). Si algo no esta en la pagina, cada pieza se salta sola y queda
   la vista de antes. Los estilos, al final de assets/section-product.css. */
(function () {
  var I = {
    truck: '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M2 6.5h11v9.5H2z"></path><path d="M13 9.5h4l3 3.5v3h-7"></path><circle cx="6.5" cy="18" r="1.8"></circle><circle cx="16.5" cy="18" r="1.8"></circle></svg>',
    pencil: '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M4 20l1-4L16.5 4.5a2.1 2.1 0 0 1 3 3L8 19l-4 1z"></path><path d="M14 7l3 3"></path></svg>',
    chair: '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M5 11V8a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v3"></path><path d="M4 11a2 2 0 0 1 2 2v1h12v-1a2 2 0 0 1 4 0c0 1.5-1 2.5-2 3v3h-2v-2H6v2H4v-3c-1-.5-2-1.5-2-3a2 2 0 0 1 2-2z"></path></svg>',
    info: '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"></circle><path d="M12 11v6"></path><path d="M12 7.5v.5"></path></svg>',
    plus: '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 5v14M5 12h14"></path></svg>'
  };
  function init() {
    try {
      var wrap = document.querySelector('.product__tabs-wrapper');
      if (wrap && !wrap.classList.contains('ew-acc')) {
        var row = wrap.querySelector('.product__tabs');
        var trigs = row ? Array.prototype.slice.call(row.querySelectorAll('.product__tab--trigger')) : [];
        if (row && trigs.length) {
          var order = [I.truck, I.pencil, I.chair];
          trigs.forEach(function (btn, i) {
            var id = btn.getAttribute('data-tab') || '';
            var content = id ? wrap.querySelector('#' + id) : null;
            row.appendChild(btn);
            if (content) row.appendChild(content);
            btn.insertAdjacentHTML('afterbegin', '<span class="ew-acc__ico">' + (order[i] || I.info) + '</span>');
            btn.insertAdjacentHTML('beforeend', '<span class="ew-acc__plusbox">' + I.plus + '</span>');
          });
          wrap.classList.add('ew-acc');
        }
      }
      // "Good to know": las notas sueltas entre las pestanias y la rejilla de confianza
      var grid = document.querySelector('.product__content-grid');
      if (wrap && grid && !document.querySelector('.ew-gtk')) {
        var chips = [];
        var node = wrap.nextElementSibling;
        while (node && node !== grid) {
          if (node.classList && node.classList.contains('product__text') && !node.classList.contains('product__inventory-notice') && (node.innerText || '').trim()) chips.push(node);
          node = node.nextElementSibling;
        }
        if (chips.length >= 2) {
          var lang = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
          var T = { en: 'Good to know', es: 'A tener en cuenta', nl: 'Goed om te weten', fr: 'Bon à savoir', pt: 'Bom saber' };
          var acc = document.createElement('div'); acc.className = 'ew-gtk';
          var head = document.createElement('button'); head.type = 'button'; head.className = 'ew-gtk__head';
          head.innerHTML = '<span class="ew-acc__ico">' + I.info + '</span><span>' + (T[lang] || T.en) + '</span><span class="ew-acc__plusbox">' + I.plus + '</span>';
          var panel = document.createElement('div'); panel.className = 'ew-gtk__panel'; panel.hidden = true;
          acc.appendChild(head); acc.appendChild(panel);
          wrap.parentNode.insertBefore(acc, wrap.nextSibling);
          chips.forEach(function (c) { panel.appendChild(c); });
          head.addEventListener('click', function () { panel.hidden = !panel.hidden; head.classList.toggle('active', !panel.hidden); });
        }
      }
      // Medidas legibles en las opciones
      document.querySelectorAll('.product__variant-options legend [data-selected-value], .product__variant-options .product-option__label span:first-child').forEach(function (sp) {
        var t = (sp.textContent || '').trim();
        if (/^\d+([.,]\d+)?\s*[xX]\s*\d+([.,]\d+)?(\s*[xX]\s*\d+([.,]\d+)?)?\s*(cm)?\.?$/i.test(t)) {
          sp.textContent = t.replace(/\s*[xX]\s*/g, ' × ').replace(/\s*cm\.?$/i, ' cm');
        }
      });
    } catch (e) {}
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
